import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import React, {useEffect, useRef, useState} from "react";
// @ts-ignore
import {v4} from "uuid";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {armor as dataarmor} from "../../_data/armor";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import {Checkbox, FormControlLabel} from "@mui/material";
import Stack from "@mui/material/Stack";
import {ICharArmor} from "../../_interfaces/ICharArmor";
import {s_char, s_char_armor} from "../../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import {modArmor} from "../../_signals/s_char_mods";
import {ArmorCreate} from "../../_api/BEArmor";


interface IProp {
    add: boolean,
    isOpen: (open: boolean) => void
}

function ArmorAdd({add, isOpen}: IProp) {
    useSignals()

    const mod_15 = [...Array(16).keys()];

    const descRef = useRef<HTMLInputElement>(null);

    const [armor, setArmor] = useState<ICharArmor | null>(null)

    useEffect(() => {

        if (add) {
            const addArmor: ICharArmor = {
                id: v4(),
                cid: s_char.value.id,
                name: '',
                descr: '',
                wear: false,
                pr: 0,
                pr_mod: 0,
                mr: 0,
                mr_mod: 0,
                ini: 0,
                ini_mod: 0
            }

            setArmor(addArmor)
        } else setArmor(null)
    }, [add])

    const save = () => {
        let charArmor = s_char_armor.value

        if (armor && armor.name !== '') {
            let curr = armor;
            curr.descr = descRef.current?.nodeValue as string ?? ''
            charArmor.unshift(curr);
            s_char_armor.value = charArmor
            modArmor(curr);
            ArmorCreate(curr)

            isOpen(false)
        }
    }

    const cancel = () => {
        isOpen(false)
    }

    return <Dialog open={add}>
        <DialogContent>
            <Select defaultValue={armor?.name || ''}
                    style={{width: "100%"}}
                    variant="standard"
            >
                {dataarmor.map(a => <MenuItem key={v4()}
                                              value={a.name}
                                              onClick={() => {
                                                  setArmor({
                                                      id: v4(),
                                                      cid: s_char.value.id,
                                                      name: a.name,
                                                      descr: '',
                                                      wear: false,
                                                      pr: a.pr,
                                                      pr_mod: 0,
                                                      mr: a.mr,
                                                      mr_mod: 0,
                                                      ini: a.ini,
                                                      ini_mod: 0
                                                  })
                                              }}>

                    {a.name} ({a.pr}/{a.mr}) <span
                    style={{marginLeft: 'auto', fontSize: "small"}}>{a.ini < 0 ? ' Ini-Malus ' + a.ini : ''}</span>
                </MenuItem>)}
            </Select>
            <TextField style={{width: '100%', marginTop: 8}}
                       defaultValue={armor?.descr || ''}
                       label={'Beschreibung'}
                       inputRef={descRef}>
            </TextField>

            <Stack style={{width: '100%', marginTop: 8}} direction={'row'}>
                <FormControlLabel style={{marginLeft: 0}} control={
                    <Checkbox defaultChecked={armor?.wear || false}
                              onChange={
                                  (e) => {
                                      let curr = armor;
                                      if (curr) {
                                          curr.wear = e.target.checked;
                                          setArmor(curr)
                                      }
                                  }
                              }
                    />
                } label="getragen"/>

                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="pr_mod_label">Modifikator physische Rüstung</InputLabel>
                    <Select defaultValue={armor?.pr_mod || 0}
                            labelId="pr_mod_label"
                            style={{width: "100%"}}
                            onChange={
                                (e) => {
                                    let curr = armor;
                                    if (curr) {
                                        curr.pr_mod = e.target.value as number;
                                        setArmor(curr)
                                    }
                                }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="mr_mod_label">Modifikator mystische Rüstung</InputLabel>
                    <Select value={armor?.mr_mod || 0}
                            labelId="mr_mod_label"
                            style={{width: "100%"}}
                            onChange={
                                (e) => {
                                    let curr = armor;
                                    if (curr) {
                                        curr.mr_mod = e.target.value as number;
                                        setArmor(curr)
                                    }
                                }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="ini_mod_label">Modifikator Initiative</InputLabel>
                    <Select defaultValue={armor?.ini_mod || 0}
                            labelId="ini_mod_label"
                            style={{width: "100%"}}
                            onChange={
                                (e) => {
                                    let curr = armor;
                                    if (curr) {
                                        curr.ini_mod = e.target.value as number;
                                        setArmor(curr)
                                    }
                                }
                            }
                    >
                        {mod_15.map(m => <MenuItem key={v4()} value={m}>{m}</MenuItem>)}
                    </Select>
                </FormControl>
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
            <Button className={'btn'} id="post" onClick={() => cancel()}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>
}

export default ArmorAdd